import React, { useContext } from "react";
import { FullScreenContext } from "../../App";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";

interface BackToExamModalProps {
    open?: boolean;
    handleClose?: () => void;
    onYes?: () => void;
}

const BackToExamModal: React.FC<BackToExamModalProps> = ({ open, handleClose, onYes }) => {
    const { handle, state } = useContext(FullScreenContext);
    const navigate = useNavigate();

    return (
        <div
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                display: state ? "none" : "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1000,
            }}
            onClick={() => handle?.enter()}
        >
            <div className="bg-black/50 h-full w-full flex justify-center items-center">
                <div
                    className="bg-white rounded-2xl p-10 w-[80%] max-w-md shadow-xl"
                    onClick={(e) => e.stopPropagation()}
                >
                    <div className="mb-5 text-center">
                        <h2 className="text-orange-500 text-xl font-bold mb-3">
                            ⚠️ Warning: Leaving the Exam
                        </h2>
                        <ul className="text-left text-sm text-gray-600 space-y-2 px-4 list-disc">
                            <li>You must complete the exam in full-screen mode.</li>
                            <li>Switching tabs or leaving the exam page may lead to disqualification.</li>
                            <li>Do not attempt to copy, share, or disclose any part of the exam content.</li>
                            <li>Ensure stable internet connectivity throughout the exam period.</li>
                        </ul>
                    </div>
                    <div className="flex justify-center gap-4 mt-6">
                        <Button
                            variant="outline"
                            className="rounded-full px-6"
                            onClick={() => { handle?.exit(); navigate("/"); }}
                        >
                            Leave Exam
                        </Button>
                        <Button
                            className="rounded-full px-6 bg-green-600 hover:bg-green-700 text-white"
                            onClick={() => handle?.enter()}
                        >
                            Return to Exam
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BackToExamModal;
